export const STANDARD_ERROR_MESSAGE =
  "Unexpected error. Please try again later or contact admin";
